<template>
  <div class="conversion">
    <div class="conversion_component">
      <h2>テキスト変換</h2>
      <hr/>
        <b-input v-model="row_text" type="textarea" placeholder="ここにテキストを入力してください。"></b-input>
        <b-button class="conversion_button" @click="conversionText">変換</b-button>
      <div v-if="isConversion">
        <hr>
        <p><strong>【結果】</strong></p>
        <div class="main_text_component">
          <div class="main_text_area">
            <p class="main_text_before">{{conversion_text[read_number]}}</p>
            <p class="main_text_center">{{conversion_text[read_number + 1]}}</p>
            <p class="main_text_after">{{conversion_text[read_number + 2]}}</p>
          </div>
        </div>
        <div class="main_button_component">
          <b-button @click="countDown" v-if="!timerOn"><span class="icon-step-backward"></span></b-button>
          <b-button @click="countDown" v-if="timerOn" disabled><span class="icon-step-backward"></span></b-button>
          <b-button @click="autoCountUp" v-if="!timerOn"><span class="icon-play"></span></b-button>
          <b-button @click="stopAutoCountUp" v-if="timerOn"><span class="icon-pause"></span></b-button>
          <b-button @click="countUp" v-if="!timerOn"><span class="icon-step-forward"></span></b-button>
          <b-button @click="countUp" v-if="timerOn" disabled><span class="icon-step-forward"></span></b-button>
        </div>
        <hr/>
        <div class="slider">
          <p><strong>表示速度の設定</strong> （{{this.value / 10}}秒）</p>
          <b-field v-if="!timerOn">
            <b-slider :min="1" :max="10" v-model="value"></b-slider>
          </b-field>
          <b-field v-if="timerOn">
            <b-slider :min="1" :max="10" v-model="value" disabled></b-slider>
          </b-field>
          <p class="progress_info">
            <b-tooltip label="読了の目安" position="is-bottom">
              <span class="icon-clock-o"></span> {{Math.floor((this.conversion_text.length - this.read_number) / (600 / this.value)) }} min
            </b-tooltip>
            <span>（{{this.read_number}}/{{this.conversion_text.length}}）</span>
          </p>
          </div>
        </div>
    </div>
  </div>

</template>

<script>
import mikan from 'mikanjs';
export default {
  data(){
    return{
      read_number: 0,
      row_text: "",
      conversion_text: [],
      timerOn: false,
      timerObj: [],
      value: 3,
      isConversion: false
    }
  },
  mounted(){
    const title = "テキスト変換｜Flatte"
    document.title = title
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
  },
  methods:{
    conversionText(){
      this.isConversion = true
      this.conversion_text = mikan.split(this.row_text)
    },
    countUp(){
      this.read_number ++;
    },
    countDown(){
      if(0 < this.read_number){
        this.read_number --;
      }
    },
    autoCountUp(){
      this.timerObj = setInterval(() => {
        if(this.read_number >= this.conversion_text.length){
          clearInterval(this.timerObj);
          setTimeout(() => {
            this.timerOn = false;
            this.read_number = 0
              }
            ,600
          )
        }else{
          this.read_number ++
        }
        }
        ,this.value * 100
      )
      this.timerOn = true;
    },
    stopAutoCountUp(){
      clearInterval(this.timerObj);
      this.timerOn = false;
    },
  }
}
</script>

<style>
h2{
    font-weight: bold;
    display: block;
    font-size: 1.17em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    text-align: center;
}
hr{
  margin:24px 0;
}
.conversion{
  background-color: #F1F5F9;
}
.conversion_title{
    font-size:1.8em;
    text-align: center;
}
.conversion_author{
  text-align: center;
}
.conversion_button{
  margin: 8px 0;
}
.conversion_component{
    max-width: 880px;
    margin: 0px auto;
    padding: 48px 16px;
}
.main_text_component{
  background-color: white;
  border-radius: 0.5em;
  margin-top:20px;
  margin-bottom: 20px;
}
.main_text_area{
  font-size:1.13em;
  max-width: 320px;
  margin: auto;
}
.main_text_center{
  padding: 4px 0;
}
.main_text_before{
  padding: 4px 0;
}
.main_text_after{
  padding: 4px 0;
}
.main_button_component{
  text-align: center;
}
.main_button_component button{
  margin: 0 8px;
}
.slider{
  max-width: 320px;
}

.progress_info{
  color: gray;
}
.side_component{
  border-radius: 0.5em;
  padding: 16px;
  background-color: #F8F8F8;
}
.conversion_info{
  padding:24px;
  font-weight: bold;
}
.conversion_info_img{
  text-align: center;
}

.display_button{
  margin: 16px 0;
}
</style>